export const STORAGE_KEYS = {
  CHARACTER_INDEXES: 'character_indexes',
  CHARACTER_PREFIX: 'character_',
};

export const ROUTES = {
  CHARACTER: '/character',
  CHARACTER_PREFIX: '/character_',
};
